export type PermissionItemLocationOnRequest = 'USER' | 'BODY' | 'QUERY' | 'PATH'

export type PermissionVerifyElementOptional = 'userId'
export type PermissionVerifyElementRequired = 'resource'
export type PermissionVerifyElement =
  | PermissionVerifyElementRequired
  | PermissionVerifyElementOptional

export type PermissionResourceType = 'INSTITUTION'

export const ResourceTypeFormat: Record<PermissionResourceType, string> = {
  INSTITUTION: 'Institution',
} as const

export type AuthenticationGuard =
  | 'SuperAdminWorkerAdminAuthGuard'
  | 'AdminAuthGuard'
  | 'SuperAdminAuthGuard'
  | 'SuperAdminAdminAuthGuard'
